interface IconBorderedProps {
  children: string | React.ReactNode;
}

const IconBordered: React.FC<IconBorderedProps> = ({ children }: IconBorderedProps) => {
  return (
    <div className='flex items-center justify-center shrink-0 w-[45px] lg:w-[60px] h-[45px] lg:h-[60px] rounded-xl border-2 border-text-primary'>
      <p className='text-[26px] lg:text-[32px] font-bold text-text-primary'>{children}</p>
    </div>
  );
};

export default IconBordered;
